<template>
  <section
    class="c-payment c-form c-form--ghost bg-white p-3 p-lg-4"
  >
    <b-skeleton-wrapper :loading="userLoading" class="mb-4">
      <template #loading>
        <b-skeleton
          no-aspect
          width="70%"
          height="100%"
          animation="fade"
          class="light mb-4"
        ></b-skeleton>

        <b-card>
          <div class="row">
            <div class="col col-12 col-md-6 mb-3">
              <b-skeleton
                no-aspect
                width="50%"
                height="20px"
                animation="fade"
                class="light mb-2"
              ></b-skeleton>
              <b-skeleton
                no-aspect
                type="input"
                height="50px"
                animation="fade"
                class="light mb-2"
              ></b-skeleton>
            </div>
            <div class="col col-12 col-md-6 mb-3">
              <b-skeleton
                no-aspect
                width="50%"
                height="20px"
                animation="fade"
                class="light mb-2"
              ></b-skeleton>
              <b-skeleton
                no-aspect
                type="input"
                height="50px"
                animation="fade"
                class="light mb-2"
              ></b-skeleton>
            </div>
            <div class="col col-12 col-md-6 mb-3 mb-md-0">
              <b-skeleton
                no-aspect
                width="50%"
                height="20px"
                animation="fade"
                class="light mb-2"
              ></b-skeleton>
              <b-skeleton
                no-aspect
                type="input"
                height="50px"
                animation="fade"
                class="light mb-2"
              ></b-skeleton>
            </div>
            <div class="col col-12 col-md-6 mb-3 mb-md-0">
              <b-skeleton
                no-aspect
                width="50%"
                height="20px"
                animation="fade"
                class="light mb-2"
              ></b-skeleton>
              <b-skeleton
                no-aspect
                type="input"
                height="50px"
                animation="fade"
                class="light mb-2"
              ></b-skeleton>
            </div>
          </div>
        </b-card>
      </template>

      <template>
        <h2 class="fs-21 w-bold darks mb-3 d-flex
          justify-content-between align-items-md-center">
          <span>Elige un medio de pago</span>
          <Countries
            v-if="country.codeOrigin === 'pe' && !pay.order"
            class="ms-2"
          >
          </Countries>
        </h2>

        <b-tabs v-model="methodIndex" class="c-tabs c-tabs--checkout mb-4">
          <b-tab>
            <template #title>
              <div class="d-flex align-items-center justify-content-center h-100">
                <img
                  class="c-icon of--contain"
                  src="@/assets/images/icons/checkout/card.svg"
                  alt="Visa" />
              </div>
            </template>
            <section>
              <div
                v-if="isTrialPlan && !userData.id"
                class="c-card-alert c-card-alert--error p-3 mb-4 text-center">
                <span>
                  Para realizar esta compra necesitas primero
                  <a
                    :href="`${arcux.site}/ingresar?back_url=${backUrl}`"
                    class="w-bold"
                    style="color: #e10000;">INGRESAR</a>
                  a tu cuenta o
                  <a
                    :href="`${arcux.site}/registrarse?back_url=${backUrl}`"
                    class="w-bold"
                    style="color: #e10000;">CREAR UNA NUEVA CUENTA.</a>
                </span>
              </div>
              <div
                v-if="card.error.active"
                class="c-card-alert c-card-alert--error p-3 mb-4 text-center"
              >
                {{ card.error.message }}
              </div>
              <div
                v-if="!userAuthenticated"
                class="c-card-alert c-card-alert--warning p-3 mb-4"
              >
                <span class="w-bold">Importante:</span> Debes usar un correo electrónico válido
              </div>
              <h3 class="fs-18 darks w-bold mb-3">Datos personales</h3>
              <div class="row">
                <div class="col col-12 col-md-6 mb-4">
                  <p class="c-form__label mb-1">Nombre completo</p>
                  <input
                    v-model.trim="user.fullName.value"
                    @keypress="isRightField($event, 'letter')"
                    @keydown.enter.tab="user.fullName.tested = true"
                    :disabled="pay.isOderLoading || pay.order != 0"
                    type="text"
                    class="c-form__input w-100"
                    tabindex="1"
                    placeholder="ej. Arcuxito Perez"
                  />
                  <span v-if="isWrongField(user.fullName)" class="c-form__error">
                    {{
                      (!user.fullName.value.length)
                        ? 'Nombre incorrecto'
                        : 'Ingresa tus nombres completos'
                    }}
                  </span>
                </div>
                <div class="col col-12 col-md-6 mb-4">
                  <p class="c-form__label mb-1">Correo electrónico</p>
                  <input
                    v-model.trim="user.email.value"
                    @keydown.enter.tab="user.email.tested = true"
                    :disabled="userData.id || pay.isOderLoading || pay.order != 0"
                    type="text"
                    data-culqi="card[email]"
                    class="c-form__input w-100"
                    tabindex="2"
                    placeholder="ej. arcuxito@ejemplo.com"
                  />
                  <span v-if="isWrongField(user.email)" class="c-form__error">
                    Correo incorrecto
                  </span>
                </div>

                <div v-if="pay.order && methodIndex === 0" class="col col-12">
                  <StripeMethod
                    :userCheckout.sync="user"
                    :isCardLoading.sync="pay.method.card.isLoading"
                    :order="pay.order"
                    :cardError.sync="card.error"
                    :purchaseCode="pay.purchase_code"
                    :clientSecret="pay.clientSecret"
                    :buyEvent="buyEvent"
                  />
                </div>
                <div v-if="!pay.order" class="col col-12">
                  <button
                    @click="createOrder()"
                    :disabled="pay.isOderLoading"
                    class="c-button c-button--primary w-100"
                    :class="{loading : pay.isOderLoading}"
                  >
                    {{
                      (pay.isOderLoading) ? 'Validando datos...' : 'Continuar con la compra'
                    }}
                    <img
                      class="c-button__spinner"
                      src="@/assets/images/animations/spinner-white.png"
                      alt="loading"
                    />
                  </button>
                </div>
              </div>
            </section>
          </b-tab>
          <b-tab v-if="!isTrialPlan && productType != 'subscription'">
            <template #title>
              <div class="d-flex align-items-center justify-content-center h-100">
                <img
                  class="c-icon of--contain"
                  src="@/assets/images/icons/checkout/paypal.svg"
                  alt="PayPal" />
              </div>
            </template>
            <section>
              <div
                v-if="paypalAlert"
                class="c-card-alert c-card-alert--success p-3 mb-4 text-center"
              >
                {{ paypalAlert }}
              </div>
              <h3 class="fs-18 darks w-bold mb-3">
                Para seguir con tu compra deberás inicar sesión en PayPal
              </h3>
              <p class="mb-0">
                Después del pago, permanece atento a tu email para recibir los
                datos de acceso al producto (verifica también la casilla de SPAM)
              </p>
            </section>
          </b-tab>
          <b-tab v-if="!isTrialPlan && productType != 'subscription'">
            <template #title>
              <p
                v-if="country.code == 'pe'"
                class="mb-0 d-flex align-items-center justify-content-center">
                <img
                  class="c-icon c-icon--cash of--contain"
                  src="@/assets/images/icons/checkout/pagoefectivo.png"
                  alt="Pago Efectivo" />
              </p>
              <p
                v-else
                class="mb-0 d-flex flex-column flex-md-row
                  align-items-center justify-content-center">
                <img
                  class="c-icon of--contain"
                  src="@/assets/images/icons/checkout/cash.svg"
                  alt="Efectivo" />
                <span class="ms-2 mt-1 mt-md-0">Efectivo</span>
              </p>
            </template>
            <section>
              <CashMethod
                v-if="arcux"
                element="body"
                :arcux="arcux"
                :product="product"
                :user="user"
                :coupon="coupon"
                :price="productPaidPrice"
                :isRightField="isRightField"
                :isWrongField="isWrongField"
                :backUrl="backUrl">
              </CashMethod>
            </section>
          </b-tab>
        </b-tabs>

        <div class="mb-4">
          <div v-show="paymentMethod == 'paypal'" key="pay-paypal">
            <div id="paypal-button-container"></div>
          </div>

          <CashMethod
            v-show="paymentMethod == 'cash'"
            key="pay-cash"
            element="button"
            :arcux="arcux"
            :product="product"
            :productPlan="productPlan"
            :user="user"
            :coupon="coupon"
            :price="productPaidPrice">
          </CashMethod>
        </div>
        <label class="c-form__checkbox-inline">
          <input v-model="user.terms" id="terms" type="checkbox" class="d-none" />
          <div class="c-square">
            <span></span>
          </div>
          <span>
            Acepto las
            <a
              :href="arcux.project.terms"
              class="c-link"
              target="_blank"
            >
              Condiciones, Términos
            </a>
            y
            <a
              :href="arcux.project.politics"
              class="c-link"
              target="_blank"
            >
              Políticas
            </a>
            de Arcux
          </span>
        </label>
        <p
          v-if="isWrongField(user.terms, 'single')"
          class="c-form__error mb-0 mt-3"
        >
          Debe aceptar las condiciones, términos y politicas
        </p>
      </template>
    </b-skeleton-wrapper>
  </section>
</template>

<script>
/* eslint-disable */
import { Icon } from '@iconify/vue2';

import PaymentDetails from '../../components/checkout/PaymentDetails.vue';
import Countries from '../../components/checkout/Countries.vue';
import CashMethod from '../../components/checkout/methods/Cash.vue';

import { validateText, validateSelect } from '../../libs/forms';

import { mapActions, mapState } from 'vuex';

export default {
  data() {
    return {
      arcux: { ...window.arcux},

      device: '',
      methodIndex: 0,

      user: {
        try: false,
        fullName: {
          value: '',
          isValid: false,
          tested: false,
          pattern: '^([a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð,._\'-]+){2,}( ){1}([a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,._\'-]{2,})$',
        },
        email: {
          value: '',
          isValid: false,
          tested: false,
          pattern: '^[a-zA-Z0-9.!#$%&\'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$',
        },
        phone:  {
          value: '',
          tested: false,
          isValid: false,
        },
        terms: true,
      },

      card: {
        try: false,

        /* TODO: Remove later */
        store: false,

        error: {
          active: false,
          message: '',
        },
      },

      pay: {
        type: 'registered',
        isLoadingRegister: false,
        isLoadingLogin: false,
        success: false,
        purchase_code: '',
        method: {
          card: {
            isLoading: false,
          },
          paypal: {
            alert: '',
            isLoading: false,
          },
          cash: {
            isLoading: false,
          },
        },

        isOderLoading: false,
        order: 0,
        clientSecret: '',
      },

      user_temp: '',
    }
  },
  components: {
    OrderSummary: () => import(/* webpackChunkName: "order-summary" */'../../components/checkout/OrderSummary.vue'),
    StripeMethod: () => import(/* webpackChunkName: "checkout-methods-stripe" */'../../components/checkout/methods/Stripe.vue'),
    PaymentDetails,
    Countries,
    CashMethod,
    Icon,
  },
  computed: {
    ...mapState({
      country: (state) => state.checkout.country,
      paymentMethod: (state) => state.checkout.paymentMethod,
      product: (state) => state.checkout.product,
      price: (state) => state.checkout.price,
      coupon: (state) => state.checkout.coupon,
      userData: (state) => state.user.userData,
      userLoading: (state) => state.user.userLoading,
    }),

    backUrl() {
      return window.location.href;
    },
    checkoutV1() {
      const fullQuery = [];

      Object.entries(this.$route.query).forEach((query) => {
        fullQuery.push(`${query[0]}=${query[1]}`);
      })

      return `/checkout/payment?${fullQuery.join('&')}`;
    },

    months() {
      return Array.from({length: 12}, (x, i) => {
        const m = i + 1;

        return (m < 10) ? `0${m}` : m;
      });
    },
    years() {
      return Array.from({length: 21}, (x, i) => i + (new Date().getFullYear()) );
    },
    cardError() {
      return this.card.error.message.replace('Contáctanos para más detalle', `<a href="${this.whatsappLink}" class="c-link"><span class="alerts">Contáctanos para más detalle</span></a>`);
    },
    paypalAlert() {
      if (this.pay.method.paypal.isLoading) {
        return 'Procesando compra...';

      } else if (this.pay.method.paypal.alert) {
        return this.pay.method.paypal.alert;

      } else {
        return false;

      }
    },

    productId() {
      let id = -1;

      if (this.$route.query.course_id) {
        id = this.$route.query.course_id;
      } else if (this.$route.query.bundle_id) {
        id = this.$route.query.bundle_id;
      } else if (this.$route.query.membership_id) {
        id = this.$route.query.membership_id;
      }

      return id;
    },
    productType() {
      return this.$route.query.membership_id
        ? 'subscription'
        : 'course';
    },
    productPlan() {
      return (this.$route.query.plan) ? this.$route.query.plan : '';
    },
    productFinalPrice() {
      return (this.price.current && this.price.current.name)
        ? `${this.price.current.amount.currency.symbol_full}${Number(this.price.current.amount.final).toLocaleString('en')}`
        : '0.00';
    },
    productPaidPrice() {
      const coupon = (this.coupon.current) ? Number(this.coupon.current.amount) : 0;

      return (this.price.current && this.price.current.name)
        ? `${this.price.current.amount.currency.symbol_full}${(Number(this.price.current.amount.final) - coupon).toLocaleString('en')}`
        : '0.00';
    },

    isTrialPlan() {
      return (this.$route.query.plan.search('trial') >= 0 || this.$route.query.plan.search('gratis') >= 0)
        ? true
        : false ;
    },

    signInLink() {
      return `${this.arcux.site}/panel/ingresar?back_url=${this.backUrl}`;
    },
    signUpLink() {
      return `${this.arcux.site}/panel/registrarse?back_url=${this.backUrl}`;
    },

    userAuthenticated() {
      return this.userData && this.userData.id
    },
  },
  watch: {
    'user.fullName.value': function() {
      this.user.fullName.isValid  = this.validateText(this.user.fullName);
    },
    'user.email.value': function() {
      this.user.email.isValid = this.validateText(this.user.email);
    },
    'card.number.value': function() {
      this.card.number.isValid = this.validateText(this.card.number);
    },
    'card.month.value': function() {
      this.validateSelect(this.card.month);
    },
    'card.year.value': function() {
      this.validateSelect(this.card.year);
    },
    'card.cvv.value': function() {
      this.card.cvv.isValid = this.validateText(this.card.cvv);
    },

    'methodIndex': function(index) {
      let method = 'visa';

      if (index === 0) {
        method = 'visa';
      } else if (index === 1) {
        method = 'paypal';
      } else  if (index === 2){
        method = 'cash';
      }

      this.setPaymentMethod(method);
    },

    'userData': function() {
      if (this.userAuthenticated) this.initUser();
    },
  },
  mounted() {
    if (this.userAuthenticated) this.initUser();

    this.loadScripts();
    this.loadGlobalScripts();

    window.setTimeout(() => {
      this.handleCheckoutWithPaypal();
    }, 2000)

    if (!(this.userAuthenticated)) {
      if (!window.sessionStorage.getItem('user_temp')) {
        window.sessionStorage.setItem('user_temp', new Date().getTime());
      }

      this.user_temp = window.sessionStorage.getItem('user_temp');
    }

    window.fbq('track', 'InitiateCheckout');
  },
  methods: {
    ...mapActions(['updatePaymentMethod']),
    validateText,
    validateSelect,

    isWrongField: function(field, type = 'multiple', context = 'user') {
      return (this[context].try || field.tested) && ((type == 'multiple') ? !field.isValid : !field);
    },
    isRightField: function(e, type) {
      const char = String.fromCharCode(e.keyCode);

      switch (type) {
        case 'letter': {
            const length = this.user.fullName.value.length;

            if ( (!length && char == ' ') || (length && this.user.fullName.value[ length - 1] == ' ' && char == ' ') ) e.preventDefault();

            if( /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,._\'-]+$/.test(char) ) return true;
            else e.preventDefault();
          }
          break;

        case 'number': {
            if( /^[0-9]+$/.test(char) ) return true;
            else e.preventDefault();
          }
          break;
      }
    },
    formatCreditCard: function (e, type) {
      if ( this.isRightField(e, type) )
        this.card.number.value = this.card.number.value
          .trim()
          .replace(/[^a-z0-9]+/gi, '')
          .replace(/(.{4})/g, '$1 ');
    },
    verifyEnroll: function() {
      const url = `${this.arcux.site}/api/v1/courses/${this.arcux.course}/students/${this.userData.id}/`;

      fetch(url)
      .then(res => {
        return res.json();
      }).then(data => {
        return data;
      });
    },

    setPaymentMethod: function(method) {
      this.updatePaymentMethod(method);
    },

    sendMetricsEvent: function(name, product, userType) {
      this.$ga.event(product, name, userType, -1);
    },
    buyEvent() {
      this.sendMetricsEvent(
        `Click Buy Button ${(this.product.type === 'course' ? 'Premium' : 'Subscription')}`,
        this.product.data.title,
        (this.userAuthenticated) ? 'REGISTERED USER' : 'NON REGISTERED USER'
      );
    },

    handleCheckoutWithPaypal: function() {
      paypal.Buttons({
        style: {
          shape: 'rect',
          color: 'white',
          layout: 'horizontal',
          label: 'pay',
          size: 'responsive',
        },
        env: process.env.VUE_APP_PROJECT_PAYPAL_ENVIRONMENT,
        onInit: (data, actions) => {
          window.document.querySelector('#terms')
            .addEventListener('change', function(event) {
              if (event.target.checked) {
                actions.enable();
              } else {
                actions.disable();
              }
            });
        },
        onClick: () => {
          this.sendMetricsEvent(
            this.product.type === 'course' ? 'Click Buy Button Premium' : 'Click Buy Button Subscription',
            this.product.data.title,
            (this.userAuthenticated) ? 'REGISTERED USER' : 'NON REGISTERED USER'
          );
        },
        createOrder: () => {
          const url = `${ this.arcux.site }/api/v1/checkout/products/${ this.product.data.id }`;

          this.pay.method.paypal.isLoading = true;

          let params = {
            plan: this.productPlan,
            payment_method: 'paypal',
            payment_gateway: 'paypal',
            country_code: this.country.codeOrigin,
            selected_country: (this.country.code == 'world' || this.country.code != 'pe') ? 'us' : 'pe',
            ... (this.pay.order) && { order: this.pay.order },
          }

          if (this.coupon.code.isValid) {
            params.coupon = this.coupon.code.value;
          }

          if (!(this.userAuthenticated)) {
            params.user_tmp = this.user_temp;
          }

          return fetch(url, {
            method: 'POST',
            body: JSON.stringify(params),
            headers: {
              'content-type': 'application/json',
              ... (this.userAuthenticated) && { Authorization: `Bearer ${window.arcux.token}` },
            },
          }).then((res) => {
            return res.json();
          }).then((data) => {
            this.pay.order = data.order;

            return data.payment;
          });
        },
        onApprove: (data, actions) => {
          return actions.order.capture().then((details) => {
            const url = `${ this.arcux.site }/api/v1/checkout/products/${ this.product.data.id }/pypl`;

            let params = {
              plan: this.productPlan,
              country_code: this.country.codeOrigin,
              selected_country: (this.country.code == 'world' || this.country.code != 'pe') ? 'us' : 'pe',
              order: this.pay.order,
              action: 'success',
            };

            if (this.coupon.code.isValid) {
              params.coupon = this.coupon.code.value;
            }

            if (!(this.userAuthenticated)) {
              this.user.fullName.value = details.payer.name.given_name + ' ' + details.payer.name.surname;

              params.user_tmp     = this.user_temp;
              params.country_code = details.payer.address.country_code;
            }

            params.email        = this.user.email.value = details.payer.email_address;
            params.first_name   = details.payer.name.given_name;
            params.last_name    = details.payer.name.surname;

            fetch(url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                ... (this.userAuthenticated) && { Authorization: `Bearer ${window.arcux.token}` },
              },
              body: JSON.stringify(params),
            })
            .then(res => {
              return res.json();
            })
            .then(data => {

              if (!data.status) {
                throw data;
              }

              this.pay.method.paypal.isLoading = false;

              if ((this.userAuthenticated)) {
                this.$router.push({
                  path: `/checkout/order-received/${this.pay.order}`,
                  query: { success: 'ok' },
                });
              } else {
                this.saveUserOnLocal(params.first_name, params.last_name);

                this.$router.push({
                  path: `/checkout/order-received/${this.pay.order}`,
                  query: {
                    pc: data.purchase_code,
                    success: 'ok',
                  },
                });
              }
            })
          })
        },
        onCancel: () => {
          const url = `${ this.arcux.site }/api/v1/checkout/products/${ this.product.data.id }/pypl`;

          let params = {
            plan: this.productPlan,
            country_code: this.country.codeOrigin,
            selected_country: this.country.code,
            order: this.pay.order,
            action: 'cancelled',
          }

          this.pay.method.paypal.isLoading = false;
          this.pay.method.paypal.alert = 'Cancelando orden...';

          return fetch(url, {
            method: 'POST',
            body: JSON.stringify(params),
            headers: {
              'content-type': 'application/json',
              ... (this.userAuthenticated) && { Authorization: `Bearer ${window.arcux.token}` },
            },
          }).then((res) => {
            return res.json();
          }).then((response) => {
            if (response.status) {
              this.pay.order = 0;
              this.pay.method.paypal.alert = 'Orden cancelada exitosamente';

              window.setTimeout(() => {
                this.pay.method.paypal.alert = '';
              }, 1000);
            }
          });
        },
      }).render('#paypal-button-container');
    },
    createOrder() {
      this.user.try = true;

      window.setTimeout(() => {
        if (
          this.user.fullName.isValid
          && this.user.email.isValid
          && this.user.terms
        ) {
          this.pay.isOderLoading = true;

          const url = `${process.env.VUE_APP_API_V2}/checkout/products/${this.productType}/orders`;
          const formData = new FormData();
          const fullname = this.user.fullName.value;
          const firstname = fullname.slice(0, fullname.indexOf(' '));
          const lastname = fullname.slice(fullname.indexOf(' ') + 1);

          formData.append('product_ids', this.productId);
          formData.append('plan', this.productPlan);
          formData.append('country_code', this.country.code);
          formData.append('firstname', firstname)
          formData.append('lastname', lastname)
          formData.append('email', this.user.email.value);

          if (this.userData.id) {
            formData.append('user_id', this.userData.id);
          } else {
            formData.append('user_tmp', this.user_temp)
          }

          fetch(url, {
            method: 'POST',
            body: formData,
          })
            .then(res => {
              if (res.status === 200 || res.status < 300) {
                return res.json();
              }

              throw res;
            })
            .then(response => {
              if (!response.status) {
                throw response;
              }

              this.pay.order = response.data.order.id;
              this.pay.clientSecret = response.data.order.token;

              if (response.data.pc) {
                this.pay.purchase_code = response.data.pc;

                this.saveUserOnLocal(firstname, lastname);
              }
            })
            .catch(err => {
              this.card.error.active  = true;
              this.card.error.message = err.message;
            }).finally(() => {
              this.pay.isOderLoading = false;
            });
        }
      }, 100);
    },

    initUser: function() {
      this.user.email.value = this.userData.email;
    },
    saveUserOnLocal(firstname, lastname) {
      window.localStorage.setItem('arcux_checkout', JSON.stringify({
        user_firstname: firstname,
        user_lastname: lastname,
      }));
    },

    loadScripts() {
      let payPalScript = document.createElement('script');
      let manyChatScript = document.createElement('script');
      let manyChatCDNScript = document.createElement('script');

      payPalScript.setAttribute('src', `https://www.paypal.com/sdk/js?client-id=${process.env.VUE_APP_PROJECT_PAYPAL_TOKEN_PUBLIC}`);

      manyChatScript.setAttribute('src', '//widget.manychat.com/769862579846062.js');
      manyChatCDNScript.setAttribute('src', 'https://mccdn.me/assets/js/widget.js');

      document.head.appendChild(payPalScript);
      document.head.appendChild(manyChatScript);
      document.head.appendChild(manyChatCDNScript);
    },
  },
}
</script>
